import { KeyboardArrowDownRounded } from "@mui/icons-material";
import {
  Autocomplete,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

export default function InputAuto(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options = [],
    error = null,
    ...other
  } = props;
  const [val, setVal] = useState(null);

  useEffect(() => {
    setVal(options.find((j) => j.id === value));
  }, [options, value]);

  const handleChange = (even, newVal) => {
    setVal(newVal);
    var e = {
      target: {
        value: newVal ? newVal.id : "",
        name: name,
      },
    };
    onChange(e);
  };

  const handleInpChg = (even, newVal) => {
    if (!newVal) {
      setVal(null);
      handleChange(null, newVal);
    }
  };

  return (
    <Autocomplete
      disableClearable
      autoHighlight
      isOptionEqualToValue={(option, value) => option.id === value.id}
      options={options}
      value={val || null}
      onChange={handleChange}
      popupIcon={<KeyboardArrowDownRounded />}
      onInputChange={handleInpChg}
      {...other}
      renderOption={(prop, opt, i) => (
        <ListItemButton
          {...prop}
          key={opt.id + i}
          sx={{ padding: "0px 15px 0px 15px !important", mb: "5px" }}
        >
          <ListItemText primary={opt.label} secondary={opt.subtitle} />
        </ListItemButton>
      )}
      componentsProps={{
        paper: {
          sx: { borderRadius: "0px 0px 10px 10px" },
        },
      }}
      renderInput={(params) => (
        <TextField
          variant={variant || "filled"}
          label={label}
          {...params}
          {...(error && { error: true, helperText: error })}
        />
      )}
    />
  );
}
